import React, { createContext, useContext, useEffect, useState, useCallback } from "react";

/**
 * Tema-håndtering (lys/mørk) for Norsk Erotikk.
 *
 * Lagring: localStorage per enhet (enkleste alternativ).
 * Default: mørk (klassisk Editorial Noir).
 * Effekt:  setter `data-theme="light"` på <html> — CSS-variabler
 *          i index.css overstyrer hele paletten automatisk.
 */
const ThemeContext = createContext({ theme: "dark", toggleTheme: () => {} });

const STORAGE_KEY = "ne_theme";

function getInitialTheme() {
  try {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved === "light" || saved === "dark") return saved;
  } catch {
    /* localStorage utilgjengelig (privat modus etc.) */
  }
  return "dark";
}

export function ThemeProvider({ children }) {
  const [theme, setTheme] = useState(getInitialTheme);

  // Sett data-theme på <html> ved hver endring + persistér
  useEffect(() => {
    const root = document.documentElement;
    if (theme === "light") {
      root.setAttribute("data-theme", "light");
    } else {
      root.removeAttribute("data-theme");
    }
    try { localStorage.setItem(STORAGE_KEY, theme); } catch { /* ignorer */ }
  }, [theme]);

  const toggleTheme = useCallback(() => {
    setTheme((t) => (t === "light" ? "dark" : "light"));
  }, []);

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  return useContext(ThemeContext);
}
